(() => {
  if (window.__lcWholesaleGateBound) return;
  window.__lcWholesaleGateBound = true;

  const SHARED_KEY = 'lc-wholesale-access';
  const EXPECTED_KEY = 'lc-wholesale-gate-expected';
  const STORAGE_KEY = 'lc-wholesale-gate-key';
  const hashedEl = document.querySelector('[data-gate-value]');
  let expected = hashedEl ? hashedEl.dataset.gateValue : '';
  let storageKey = hashedEl ? hashedEl.dataset.storageKey : '';
  const errorMessage =
    (hashedEl && hashedEl.dataset.errorMessage) || 'Incorrect password. Please try again.';
  const forms = document.querySelectorAll('[data-collection-password-form]');

  const refreshTransparentHeader = () => {
    const stickyHeader = document.querySelector('sticky-header');
    if (stickyHeader && typeof stickyHeader.setHeaderHeight === 'function') {
      if (typeof stickyHeader.initTransparentHeader === 'function') {
        stickyHeader.initTransparentHeader();
      }
      stickyHeader.setHeaderHeight();
      if (typeof stickyHeader.syncTransparentHeader === 'function') {
        stickyHeader.syncTransparentHeader();
      }
      return;
    }

    document.dispatchEvent(new CustomEvent('collection-password:unlocked'));
  };

  const unlock = () => {
    document.documentElement.classList.remove('collection-password-locked');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent('collection-password:unlocked'));
        refreshTransparentHeader();
      });
    });
  };

  const readCache = () => {
    try {
      if (!expected) expected = sessionStorage.getItem(EXPECTED_KEY) || '';
      if (!storageKey) storageKey = sessionStorage.getItem(STORAGE_KEY) || '';
    } catch (error) {}
  };

  const writeCache = () => {
    try {
      if (expected) sessionStorage.setItem(EXPECTED_KEY, expected);
      if (storageKey) sessionStorage.setItem(STORAGE_KEY, storageKey);
    } catch (error) {}
  };

  const loadExpected = async () => {
    readCache();
    if (expected) return expected;

    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}collections/wholesale`);
      if (!response.ok) return '';
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const el = doc.querySelector('[data-gate-value]');
      if (!el) return '';
      expected = el.dataset.gateValue || '';
      storageKey = el.dataset.storageKey || storageKey;
      writeCache();
    } catch (error) {}

    return expected;
  };

  try {
    if (hashedEl && hashedEl.dataset.gateValue) {
      expected = hashedEl.dataset.gateValue;
      storageKey = hashedEl.dataset.storageKey || storageKey;
      writeCache();
    }
    readCache();
    if (
      sessionStorage.getItem(SHARED_KEY) === '1' ||
      (storageKey && sessionStorage.getItem(storageKey) === '1')
    ) {
      unlock();
      return;
    }
  } catch (error) {}

  document.documentElement.classList.add('collection-password-locked');
  if (!forms.length) return;

  loadExpected();

  const encodeValue = (value) => {
    try {
      return btoa(unescape(encodeURIComponent(value)));
    } catch (error) {
      return '';
    }
  };

  forms.forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const errorEl = form.querySelector('[data-collection-password-error]');
      if (errorEl) errorEl.textContent = '';

      const input = form.querySelector('input[name="password"]');
      const value = input ? input.value.trim() : '';
      if (!value) return;

      const gateValue = await loadExpected();
      if (!gateValue || encodeValue(value) !== gateValue) {
        if (errorEl) errorEl.textContent = errorMessage;
        return;
      }

      try {
        sessionStorage.setItem(SHARED_KEY, '1');
        if (storageKey) sessionStorage.setItem(storageKey, '1');
      } catch (error) {}

      unlock();
    });
  });
})();
